/* 比赛实时推送，推送规则请看接口文档 */
import PushCenter from './Push'
import { getTopic } from './pushTopic'

class BetPush extends PushCenter {
  /**
   * 订阅/取消订阅 比赛信息推送
   * @param  {Number}   options.type         订阅类型: 1, 2, 3 . 1表示 eventStatus, 2表示 marketStatus, 3表示 marketOdds
   * @param  {String}   options.sportId      sport id, 必需
   * @param  {String}   options.categoryId   category id, 默认通配符 "~"
   * @param  {String}   options.tournamentId tournament id, 默认通配符 "~"
   * @param  {String}   options.eventId      event id, 默认通配符 "~"
   * @param  {String}   options.productId    product id; market消息和odds消息需要，也可以不传递, 默认通配符 "~"
   * @param  {String|Array}  options.marketIds    market id string 或者 ids array; 订阅market消息的时候有, 默认通配符 "~"
   * @param  {String}   specifiers           market specifiers 值，默认不传
   * @param  {Function} callback             callback, 注意引用关系，取消订阅时需要传入原函数
   * @param  {Boolean}  isSub                是否订阅，true表示 sub，false表示 unsub，默认 sub
   * @return {Null}                          Null
   */
  pushTopic({ type = 1, sportId = '', categoryId = '', tournamentId = '', eventId, productId, marketIds, specifiers, pushType = 'GROUP' }, callback = null, isSub = true) {
    if (!sportId) {
      console.error('sportId is required!')
      return
    }

    // 如果是unsub, listener不传递表示订阅这几个主题的都取消
    const noop = () => ({})
    const listener = isSub ? callback || noop : callback

    // 解析 topic
    const resolveTopic = (marketId) =>
      getTopic(
        {
          sportId,
          categoryId,
          tournamentId,
          eventId,
          productId,
          marketId,
          specifiers
        },
        type
      )

    // event status
    if (type === 1 || !Array.isArray(marketIds)) {
      const topic = resolveTopic(marketIds)
      if (isSub) {
        this.sub({ topic, pushType, listener })
      } else {
        this.unsub({ topic, pushType, listener })
      }
    } else if (marketIds.length) {
      // 多个market
      marketIds.forEach((marketId) => {
        // marketSpecifiers
        const topic = resolveTopic(marketId)
        if (isSub) {
          this.sub({ topic, pushType, listener })
        } else {
          this.unsub({ topic, pushType, listener })
        }
      })
    }
  }
}

export default BetPush
